<template>
    <div class="tab-pane " role="tabpanel" aria-labelledby="home-tab">
        <div class="row mb-3 mt-3">
            <div class="col-md-3">
                <b-button-group>
                    <b-button variant="outline-danger">
                        <input type="checkbox" v-model="selectAll" @change="selectItemAll(selectAll)" />
                    </b-button>
                    <b-button variant="outline-danger" type="button" :disabled="recordIds.length == 0" @click="multiDelete" v-if="$role=='super_admin'">
                        <i class="fa fa-trash"></i>
                        {{ $t("site.bulk_delete") }}
                    </b-button>
                </b-button-group>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <input type="text" autofocus class="form-control" v-model="search" @input="(val) => searchChange(val)" :placeholder="$t(`site.search`)" />
                </div>
            </div>
            <div class="col-3">
                <div class="float-md-right pt-1">
                    <span class="text-muted text-small mr-1 mb-2">
                        {{ from }}:{{ to }}
                    </span>

                    <b-dropdown id="ddown2" right :text="`${perPage}`" variant="outline-warning" size="xs">
                        <b-dropdown-item v-for="(size, index) in [5, 10, 20, 50, 100]" :key="index" @click="changePageSize(size)">{{ size }}</b-dropdown-item>
                    </b-dropdown>
                    <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-md-12 overflow-auto">
                <b-table :stacked="($mobile==1)"  responsive  ref="table" class="vuetable" sort-by="id" sort-desc.sync="false" :current-page="currentPage" :fields="bootstrapTable.fields" :items="dataProvider">
                    <template #cell(checkbox)="data">
                        <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
                            <input type="checkbox"
                                   v-model="recordIds"
                                   :value="data.item.id"
                                   @change="selectItem(data)" />
                            <span></span>
                        </label>
                    </template>
                    <!--<template #cell(checkbox)="data">
                        
                    </template>-->
                    <template #cell(edit)="data">
                        <button class="btn btn-icon btn-warning btn-sm" @click="editItem(data)">
                            <i class="fa fa-edit"></i>
                        </button>
                        <button class="btn btn-icon btn-danger btn-sm  "  @click="deleteItem(data)" v-if="$role=='super_admin'">
                            <i class="fa fa-trash"></i>
                        </button>
                    </template>

                    <b-spinner v-if="load" type="grow" label="Loading..."  class="loading" />
                </b-table>

                <hr/>
          <b-pagination size="sm" align="right" class="dataTables_paginate paging_simple_numbers pagination-warning" :total-rows="totalRows" :per-page="perPage" v-model="currentPage">
                    <template v-slot:next-text>
                        <i class="fas fa-angle-left" />
                    </template>
                    <template v-slot:prev-text>
                        <i class="fas fa-angle-right" />
                    </template>
                    <template v-slot:first-text>
                        <i class="fas fa-step-forward" />
                    </template>
                    <template v-slot:last-text>
                        <i class="fas fa-step-backward" />
                    </template>
                </b-pagination>

             </div>
            <!-- end of col -->
        </div>
        <!-- end of row -->
    </div>
</template>

<script>
    import controller from "../../../../Controllers/BonusesController";
    import config from "../../../../config/config";
    export default {
        name: "BonusesDataTable",
        props: ["items", "editItem"],
        data() {
            return {
                bootstrapTable: {
                    selected: [],
                    selectMode: "multi",
                    fields: [
                        { key: "checkbox", label: "", sortable: false },
                                               {key: 'name',label: this.$i18n.t('bonuses.name'), sortable: true, sortDirection: 'desc'},
                     {key: 'amount',label: this.$i18n.t('bonuses.amount'), sortable: true, sortDirection: 'desc'},
                     {key: 'month',label: this.$i18n.t('bonuses.month'), sortable: true, sortDirection: 'desc'},
                     {key: 'description',label: this.$i18n.t('bonuses.description'), sortable: true, sortDirection: 'desc'},

                          { key: "edit", label: this.$i18n.t("site.action"), sortable: false },
                ],
        },
        data: {},
        selectAll: false,
        
        currentPage: 1,
        select: [],
        page: 1,
        perPage: 5,
        search: "",
        from: 0,
        total: 0,
        totalRows: 0,
        to: 0,
        lastPage: 0,
        load: false,
        apiParams: {},
        params: {},
        recordIds: [],
    };
    },
    methods: {
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        async dataProvider(ctx) {
            this.load = true;
            this.params = ctx;
            const data = await new controller().GetAll(this.apiParamsConverter());
            this.currentPage = data.current_page;
            this.perPage = data.per_page;
            this.totalRows = data.total;
            this.from = data.from;
            this.to = data.to;
            this.total = data.total;
            this.data = data.data;
            this.load = false;
            return data.data;
        },
        apiParamsConverter() {
            let apiParams = { per_page: this.perPage };
            if (this.params.currentPage >= 1) {
                apiParams.page = this.params.currentPage;
            }
            if (this.params.sortBy && this.params.sortBy.length > 0) {
                apiParams.sort = `${this.params.sortBy}|${this.params.sortDesc ? "desc" : "asc"
                    }`;
            }
            if (this.params.filter && this.params.filter.length > 0) {
                // Optional
            }
            if (this.search !== "") {
                apiParams.search = this.search;
            }
            return apiParams;
        },
        changePageSize(perPage) {
            this.page = 1;
            this.perPage = perPage;
            this.dataProvider(this.params);
            this.$refs.table.refresh();
        },
        searchChange() {
            if (this.search.length == 0) {
                this.dataProvider(this.params);
                this.$refs.table.refresh();
            }
            if (this.search.length < 2) return;
            this.page = 1;
            this.dataProvider(this.params);
            this.$refs.table.refresh();
        },
        selectItemAll(select) {
            this.recordIds = [];
            if (select) {
                console.log(this.data);
                this.data.forEach((element) => {
                    this.recordIds.push(element.id);
                });
            }
        },
        deleteItem(data) {
            new controller().Delete(data.item.id, [], this.$refs.table);
        },
        multiDelete() {
            new controller().Delete(0, this.recordIds, this.$refs.table);
        },
    },
};
</script>

